import { render } from "./FeesModal.vue?vue&type=template&id=efa91238&ts=true"
import script from "./FeesModal.vue?vue&type=script&lang=ts"
export * from "./FeesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__